/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".header[_ngcontent-%COMP%]{height:40px;background-color:#42b0d5;z-index:1000;position:fixed;width:100%}"];
export { styles as styles };

